import { createReducer, on } from '@ngrx/store'
import { Bank } from 'app/modules/products/_state/products.interfaces'
import * as bulkPayActions from './bulk-pay.actions'
import { Country, Recipient, RecipientCategory, XcelAccount } from './bulk-pay.interfaces'
export interface BulkPayState {
    countries: Country[] | null
    countriesError: boolean
    loadingCountries: boolean

    recipientCategories: RecipientCategory[] | null
    fetchRecipientCategoriesError: boolean
    loadingRecipientCategories: boolean

    pagination: { total: number; page: number; limit: number; totalPages: number };

    recipients: Recipient[] | null
    fetchRecipientsError: boolean
    loadingRecipients: boolean

    xcelAccount: XcelAccount | null
    validateXcelAccountError: boolean
    validatingXcelAccount: boolean

    categoryRecipients: Recipient[] | null
    fetchCategoryRecipientsError: boolean
    loadingCategoryRecipients: boolean

    accountBalance
    fetchAccountBalanceError: boolean
    loadingAccountBalance: boolean

    recipientBanks: Bank[] | null
    recipientBanksError: boolean
    recipientBanksLoading: boolean

}

export const initialState: BulkPayState = {
    countries:  null,
    countriesError: null,
    loadingCountries: null,

    recipientCategories: null,
    fetchRecipientCategoriesError: null,
    loadingRecipientCategories: null,

    pagination: { total: 0, page: 1, limit: 10, totalPages: 0 },

    recipients: null,
    fetchRecipientsError: null,
    loadingRecipients: null,

    xcelAccount:  null,
    validateXcelAccountError: null,
    validatingXcelAccount: null,

    categoryRecipients:  null,
    fetchCategoryRecipientsError: null,
    loadingCategoryRecipients: null,

    accountBalance: null,
    fetchAccountBalanceError: null,
    loadingAccountBalance: null,

    recipientBanks: null,
    recipientBanksError: null,
    recipientBanksLoading: null,
}

export const BulkPayReducer = createReducer(
    initialState,

    on(bulkPayActions.fetchCountries, (state) => ({
        ...state, countries: null, countriesError: null, loadingCountries: true
    })),

    on(bulkPayActions.fetchCountriesSuccess, (state, {countries}) => ({
        ...state, countries: countries, countriesError: false, loadingCountries: false
    })),

    on(bulkPayActions.fetchCountriesFailed, (state) => ({
        ...state, countries: null, countriesError: true, loadingCountries: false
    })),


    on(bulkPayActions.fetchRecipientCategories, (state) => ({
        ...state, recipientCategories: null, fetchRecipientCategoriesError: null, loadingRecipientCategories: true
    })),

    on(bulkPayActions.fetchRecipientCategoriesSuccess, (state, { recipientCategories, pagination }) => ({
        ...state,
        recipientCategories,
        pagination, 
        loadingRecipientCategories: false,
        fetchRecipientCategoriesError: false
      })),

    on(bulkPayActions.fetchRecipientCategoriesFailed, (state) => ({
        ...state, recipientCategories: null, fetchRecipientCategoriesError: true, loadingRecipientCategories: false
    })),


    
    on(bulkPayActions.fetchRecipients, (state) => ({
        ...state, recipients: null, fetchRecipientsError: null, loadingRecipients: true
    })),

    on(bulkPayActions.fetchRecipientsSuccess, (state, {recipients}) => ({
        ...state, recipients: recipients, fetchRecipientsError: false, loadingRecipients: false
    })),

    on(bulkPayActions.fetchRecipientsFailed, (state) => ({
        ...state, recipients: null, fetchRecipientsError: true, loadingRecipients: false
    })),


    on(bulkPayActions.validateXcelAccount, (state) => ({
        ...state, xcelAccount: null, validateXcelAccountError: null, validatingXcelAccount: true
    })),

    on(bulkPayActions.validateXcelAccountSuccess, (state, {xcelAccount}) => ({
        ...state, xcelAccount: xcelAccount, validateXcelAccountError: false, validatingXcelAccount: false
    })),

    on(bulkPayActions.validateXcelAccountFailed, (state) => ({
        ...state, xcelAccount: null, validateXcelAccountError: true, validatingXcelAccount: false
    })),


    on(bulkPayActions.fetchRecipientsByCategory, (state) => ({
        ...state, categoryRecipients: null, fetchCategoryRecipientsError: null, loadingCategoryRecipients: true
    })),

    on(bulkPayActions.fetchRecipientsByCategorySuccess, (state, {recipients}) => ({
        ...state, categoryRecipients: recipients, fetchCategoryRecipientsError: false, loadingCategoryRecipients: false
    })),

    on(bulkPayActions.fetchRecipientsByCategoryFailed, (state) => ({
        ...state, categoryRecipients: null, fetchCategoryRecipientsError: true, loadingCategoryRecipients: false
    })),



    on(bulkPayActions.fetchAccountBalance, (state) => ({
        ...state, accountBalance: null, fetchAccountBalanceError: null, loadingAccountBalance: true
    })),

    on(bulkPayActions.fetchAccountBalanceSuccess, (state, {balance}) => ({
        ...state, accountBalance: balance, fetchAccountBalanceError: false, loadingAccountBalance: false
    })),

    on(bulkPayActions.fetchAccountBalanceFailed, (state) => ({
        ...state, accountBalance: null, fetchAccountBalanceError: true, loadingAccountBalance: false
    })),


    on(bulkPayActions.fetchRecipientBanks, (state) => ({
        ...state, recipientBanks: null, recipientBanksError: null, recipientBanksLoading: true
    })),

    on(bulkPayActions.fetchRecipientBanksSuccess, (state, {banks}) => ({
        ...state, recipientBanks: banks, recipientBanksError: false, recipientBanksLoading: false
    })),

    on(bulkPayActions.fetchRecipientBanksFailed, (state) => ({
        ...state, recipientBanks: null, recipientBanksError: true, recipientBanksLoading: false
    })),


)